import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { FaFilePdf } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { convertToMarathiNumber } from '../../components/marathiNumbers';
import Irlamumbai from '../../assets/documents/Excavation/ratnagiri/001_Indian_Archaeology_A_Review_1989-90.pdf';
import kausathane from '../../assets/documents/Excavation/ratnagiri/002_Indian_Archaeology_A_Review_1965-66.pdf';
import Panhaleratnagiri from '../../assets/documents/Excavation/ratnagiri/003_Indian_Archaeology_A_Review.zip';
import paithansambhajinagar from '../../assets/documents/Excavation/Chhatrapatisambhajinagar/002_Indian_Archaeology_A_Review.zip';
import Tersambhajinagar from '../../assets/documents/Excavation/Chhatrapatisambhajinagar/003_Indian_Archaeology_A_Review.zip';
import Kaundanpurnagpur from '../../assets/documents/Excavation/nagpur/002_Indian_Archaeology_A_Review_1961-62.pdf';
import Khairwadanagpur from '../../assets/documents/Excavation/nagpur/003_Indian_Archaeology_A_Review_1981-82.pdf';
import Mulchernagpur from '../../assets/documents/Excavation/nagpur/004_Indian_Archaeology_A_Review_1987-88.pdf';
import Nagranagpur from '../../assets/documents/Excavation/nagpur/005_Indian_Archaeology_A_Review.zip';
import Chandankhedanagpur from '../../assets/documents/Excavation/nagpur/012_A_Report_on_Excavations_at_Chandankheda.pdf';
import Kandaharnanded from '../../assets/documents/Excavation/nanded/002_Indian_Archaeology_A_Review_1983-84.pdf';



const documents = {
    ratnagiri: [
        {
            id: 1,
            place: {
                English: "Irla (Mumbai)",
                मराठी: "इर्ला(मुंबई)"
            },
            year: {
                English: "1989-90",
                मराठी: "१९८९-९०"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums, Government of Maharashtra",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1989-90, p. 69",
                मराठी: "IAR १९८९-९०, पृ. ६९"
            },
            download: Irlamumbai
        },
        {
            id: 2,
            place: {
                English: "Kausa (Thane)",
                मराठी: "कौसा (ठाणे)"
            },
            year: {
                English: "1965-66",
                मराठी: "१९६५-६६"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums, Government of Maharashtra",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1965-66, pp. 28-29. by M. G. Dikshit",
                मराठी: "IAR १९६५-६६, पृ. २८-२९. एम. जी. दीक्षित"
            },
            download: kausathane,
        },
        {
            id: 3,
            place: {
                English: "Panhale Kaji (Ratnagiri)",
                मराठी: "पन्हाळे काजी (रत्नागिरी)"
            },
            year: {
                English: "1973-74;1977-78;1979-80",
                मराठी: "१९७३-७४; १९७७-७८; १९७९-८०"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums, Government of Maharashtra",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1973-74, p.22; 1977-78, pp.41-42; 1979-80, p.59. M.N. Deshpande",
                मराठी: "IAR १९७३-७४, पृ. २२; १९७७-७८, पृ. ४१-४२; १९७९-८०, पृ. ५९. एम. एन. देशपांडे"
            },
            download: Panhaleratnagiri
        },
    ],
    nashik: [
        {
            id: 1,
            place: {
                English: "Nagalwadi (Ahilyanagar)",
                मराठी: "नागलवाडी (अहिल्यानगर)"
            },
            year: {
                English: "2004-05",
                मराठी: "२००४-०५"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "R.R. Borkar",
                मराठी: "आर. आर. बोरकर"
            },
        },
        {
            id: 2,
            place: {
                English: "Tahlner (Dhule)",
                मराठी: "तहलनर(धुळे)"
            },
            year: {
                English: "1985-86",
                मराठी: "१९८५-८६"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "Brother-in-law",
                मराठी: "साळी"
            },
        },
    ],
    pune: [
        {
            id: 1,
            place: {
                English: "Junnar (Pune)",
                मराठी: "जुन्नर (पुणे)"
            },
            year: {
                English: "1984-85",
                मराठी: "१९८४-८५"
            },
            excavatedBy: {
                English: "Deccan College, Pune and Directorate of Archaeology and Museums",
                मराठी: "डेक्कन कॉलेज, पुणे आणि पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "Jadhav 2005, Man and Environment",
                मराठी: "जाधव २००५, मॅन अँड एनवायरंमेंट"
            },
        },
    ],
    chhatrapatisambhajinagar: [
        {
            id: 1,
            place: {
                English: "Daulatabad (Chhatrapati Sambhajinagar)",
                मराठी: "दौलताबाद (छत्रपती संभाजीनगर)"
            },
            year: {
                English: "1984-85",
                मराठी: "१९८४-८५"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "Report not published",
                मराठी: "अहवाल प्रकाक्षशत नाही"
            },
        },
        {
            id: 2,
            place: {
                English: "Paithan (Chhatrapati Sambhajinagar)",
                मराठी: "पैठण (छत्रपती संभाजीनगर)"
            },
            year: {
                English: "1965-66; 1995-99",
                मराठी: "१९६५-६६; १९९५-९९"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums, Archaeological Survey of India",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय, भारतीय पुरातत्त्व सर्वेक्षण"
            },
            reference: {
                English: "IAR 1965-66, pp. 28-29; 1995-96, pp. 56; 1996-97, pp. 70; 1997-98, pp. 125; 1998-99, pp. 107. Kavadkar Charcha-0240-2489778",
                मराठी: "IAR १९६५-६६, पृ. २८-२९; १९९५-९६, पृ. ५६; १९९६-९७, पृ. ७०; १९९७-९८, पृ. १२५; १९९८-९९, पृ. १०७. कवडकऱ चर्चा-०२४०-२४८९७७८"
            },
            download: paithansambhajinagar,
        },
        {
            id: 3,
            place: {
                English: "Ter (Dharashiv)",
                मराठी: "तेर (धाराशिव)"
            },
            year: {
                English: "1957-58; 1966-1969; 1974-75; 1982-83; 1987-88; 1988-90",
                मराठी: "१९५७-५८; १९६६-१९६९; १९७४-७५; १९८२-८३; १९८७-८८; १९८८-९०"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1957-58, pp. 23-24; 1966-67, pp. 25-26; 1967-68, pp. 35; 1968-69, pp. 17-18; 1974-75, p. 32; 1987-88 God and the Bride, pp. 87-88; 1988-89, pp. 62-63. God and the Bride",
                मराठी: "IAR १९५७-५८, पृ. २३-२४; १९६६-६७, पृ. २५-२६; १९६७-६८, पृ. ३५; १९६८-६९, पृ. १७-१८; १९७४-७५, पृ. ३२; १९८७-८८ गॉड अँड द ब्राइड, पृ. ८७-८८; १९८८-८९, पृ. ६२-६३. गॉड अँड द ब्राइड"
            },
            download: Tersambhajinagar
        },
    ],
    nanded: [
        {
            id: 1,
            place: {
                English: "Charthana (Parbhani)",
                मराठी: "चारठाणा (परभणी)"
            },
            year: {
                English: "1982-83",
                मराठी: "१९८२-८३"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "Clearance work",
                मराठी: "क्लिअरन्स काम"
            },
        },
        {
            id: 2,
            place: {
                English: "Kandahar (Nanded)",
                मराठी: "कंधार (नांदेड)"
            },
            year: {
                English: "1983-84",
                मराठी: "१९८३-८४"
            },
            excavatedBy: {
                English: "Deccan College, Pune and Directorate of Archaeology and Museums",
                मराठी: "डेक्कन कॉलेज, पुणे आणि पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1983-84, p. 58-59",
                मराठी: "IAR १९८३-८४, पृ. ५८-५९"
            },
            download: Kandaharnanded,
        },
    ],
    nagpur: [
        {
            id: 1,
            place: {
                English: "Bhandaka (Bhadravati)",
                मराठी: "भंडक (भद्रावती)"
            },
            year: {
                English: "2006-07",
                मराठी: "२००६-०७"
            },
            excavatedBy: {
                English: "Nagpur University and Directorate of Archaeology and Museums",
                मराठी: "नागपूर विद्यापीठ आणि पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "Nagpur District Report",
                मराठी: "नागपूर जि.अहवाल"
            },
        },
        {
            id: 2,
            place: {
                English: "Kaundanpur (Amravati)",
                मराठी: "कौंडनपूर (अमरावती)"
            },
            year: {
                English: "1961-62",
                मराठी: "१९६१-६२"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1961-62, p. 29-30",
                मराठी: "IAR १९६१-६२, पृ. २९-३०"
            },
            download: Kaundanpurnagpur,
        },
        {
            id: 3,
            place: {
                English: "Khairwada (Wardha)",
                मराठी: "खैरवाडा (वर्धा)"
            },
            year: {
                English: "1981-82",
                मराठी: "१९८१-८२"
            },
            excavatedBy: {
                English: "Deccan College, Pune and Directorate of Archaeology and Museums",
                मराठी: "डेक्कन कॉलेज, पुणे आणि पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1981-82, p. 51-52",
                मराठी: "IAR १९८१-८२, पृ. ५१-५२"
            },
            download: Khairwadanagpur,
        },
        {
            id: 4,
            place: {
                English: "Mulcher (Gadchiroli)",
                मराठी: "मुलचेरा (गडचिरोली)"
            },
            year: {
                English: "1987-89",
                मराठी: "१९८७-८९"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1987-88, p. 84; 1988-89, p. 49, Saali",
                मराठी: "IAR १९८७-८८, पृ. ८४; १९८८-८९, पृ. ४९. साळी"
            },
            download: Mulchernagpur,
        },
        {
            id: 5,
            place: {
                English: "Nagra (Gondia)",
                मराठी: "नागरा(गोंदिया)"
            },
            year: {
                English: "1979-82",
                मराठी: "१९७९-८२"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "IAR 1979-80, p. 56; 1980-81, p. 40; 1981-82, p. 49. AIIS Volume Jamkhedkar",
                मराठी: "IAR १९७९-८०, पृ. ५६; १९८०-८१, पृ. ४०; १९८१-८२, पृ. ४९. ए. आय. आय. एस. खंड जामखेडकर"
            },
            download: Nagranagpur,
        },
        {
            id: 6,
            place: {
                English: "Naikunda (Nagpur)",
                मराठी: "नायकुंड (नागपूर)"
            },
            year: {
                English: "1978-80",
                मराठी: "१९७८-८०"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "S.B. Dev and Dr. A. P. Jamkhedkar, 1982 Excavations at Naikund (1978-80)",
                मराठी: "स.ब. देव आक्षण डॉ. अ. प जामखेडकर, १९८२ एकस्कावेशनस एटनायकुं ड (१९७८-८०)"
            },
        },
        {
            id: 7,
            place: {
                English: "Mahurjari (Nagpur)",
                मराठी: "माहुजरी (नागपूर)"
            },
            year: {
                English: "1970-72",
                मराठी: "१९७०-७२"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "S.B. Dev 1973 Mahurjarri Excavation 1970-72",
                मराठी: "स.ब. देव १९७३ माहुजरी एकस्कावेशन १९७०-७२"
            },
        },
        {
            id: 8,
            place: {
                English: "Borgaon (Nagpur)",
                मराठी: "बोरगाव (नागपूर)"
            },
            year: {
                English: "1980-81",
                मराठी: "१९८०-८१"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "-",
                मराठी: "-"
            },
        },
        {
            id: 9,
            place: {
                English: "Hamalapuri (Nagpur)",
                मराठी: "हमालापुरी (नागपूर)"
            },
            year: {
                English: "1982-83",
                मराठी: "१९८२-८३"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "-",
                मराठी: "-"
            },
        },
        {
            id: 10,
            place: {
                English: "Mandala (Nagpur)",
                मराठी: "मंडळ (नागपूर)"
            },
            year: {
                English: "1984-85; 1991-92",
                मराठी: "१९८४-८५; १९९१-९२"
            },
            excavatedBy: {
                English: "Nagpur University and Directorate of Archaeology and Museums",
                मराठी: "नागपूर विद्यापीठ आणि पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "A.M. Shastri 1978 Mandala Excavations (Hindi), p. 142-174",
                मराठी: "अ.म. शास्त्री १९७८ मंडळ उत्खनन (हिंदी), पृ. १४२-१७४"
            },
        },
        {
            id: 11,
            place: {
                English: "Washim (Washim)",
                मराठी: "वाशीम (वाशीम)"
            },
            year: {
                English: "1992-96",
                मराठी: "१९९२-९६"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "-",
                मराठी: "-"
            },
        },
        {
            id: 12,
            place: {
                English: "Chandankheda (Chandrapur)",
                मराठी: "चंदनखेडा (चंद्रपूर)"
            },
            year: {
                English: "2009-10",
                मराठी: "२००९-१०"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums, Nagpur University and INTACH Chandrapur Division",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय, नागपूर विद्यापीठ आणि INTACH चंद्रपूर खंड"
            },
            reference: {
                English: "Meshram et al. 2015",
                मराठी: "मेश्राम  et al. २०१५"
            },
            download: Chandankhedanagpur,
        },
        {
            id: 13,
            place: {
                English: "Malli (Gondia)",
                मराठी: "मल्ली (गोंदिया)"
            },
            year: {
                English: "2010-11; 2012-13",
                मराठी: "२०१०-११; २०१२-१३"
            },
            excavatedBy: {
                English: "Directorate of Archaeology and Museums",
                मराठी: "पुरातत्त्व व वस्तुसंग्रहालये संचालनालय"
            },
            reference: {
                English: "V. G. Sontakke, 2015 Man and Environment Vol. XL (1)",
                मराठी: "व. ग. सोनटक्के, २०१५ मॅन अँड एनवायरंमेंट Vol.XL (१)"
            },
        },
    ],
};

const RatnagiriPage = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);
    const { division } = useParams(); // gets "ratnagiri", "nashik", etc.
    const divisionDocs = documents[division] || [];

    const content = {
        English: {
            title: "Explorations & EXCAVATIONS",
            breadcrumbHome: "HOME",
            breadcrumbMuseum: "EXPLORATIONS & EXCAVATIONS",
            divisionTitle: division,
        },
        मराठी: {
            title: "अन्वेषण आणि उत्खनन",
            breadcrumb: "रत्नागिरी विभाग",
            breadcrumbHome: "मुख्यपृष्ठ ",
            breadcrumbMuseum: "अन्वेषण आणि उत्खनन",
            divisionTitle: division,
        }
    };

    const divisionNames = {
        ratnagiri: { English: "Ratnagiri", मराठी: "रत्नागिरी" },
        nashik: { English: "Nashik", मराठी: "नाशिक" },
        pune: { English: "Pune", मराठी: "पुणे" },
        chhatrapatisambhajinagar: { English: "Chhatrapati Sambhajinagar", मराठी: "छत्रपती संभाजी नगर" },
        nanded: { English: "Nanded", मराठी: "नांदेड" },
        nagpur: { English: "Nagpur", मराठी: "नागपूर" }
    };

    const tableHeaders = {
        srNo: {
            English: "Sr. No.",
            मराठी: "अ.क्र.",
        },
        place: {
            English: "Place",
            मराठी: "ठिकाण",
        },
        year: {
            English: `Year`,
            मराठी: `वर्ष`,
        },
        excavatedBy: {
            English: `Excavated by`,
            मराठी: `कोणाकडून उत्खनन`,
        },
        reference: {
            English: `Reference`,
            मराठी: `वर्ष`,
        },
        download: {
            English: `Download`,
            मराठी: `डाउनलोड`,
        },
    };


    const t = content[selectedLang];
    const divisionTitle = divisionNames[division]?.[selectedLang] || division;

    return (
        <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
            <div className="text-center mb-8">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">{t.title}</h1>
                <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {t.breadcrumbHome}
                        </Link>{" "}/{" "}
                        <Link
                            to="/excavations"
                            className="hover:underline"
                            style={{ color: "#DD9827" }}
                        >
                            {t.breadcrumbMuseum}
                        </Link>{" "}/{" "}</span>
                    {" "}<span className="uppercase">{divisionTitle}</span>
                </p>
            </div>

            <div className="max-w-5xl mx-auto">
                <div
                    className="overflow-hidden no-dark-bg"
                >
                    <div className="overflow-x-auto bg-[#EFEDE0] rounded-xl " style={{ border: "2px solid #F8D6BF" }}>
                        <table className="min-w-full text-center text-black text-sm sm:text-base">
                            <thead className='font-bold tracking-wide' style={{
                                textShadow: '0.3px 0.3px 0 black',
                                borderBottom: '2px solid #F8D6BF'
                            }}>
                                <tr>
                                    <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {tableHeaders.srNo[selectedLang]}
                                    </th>
                                    <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {tableHeaders.place[selectedLang]}
                                    </th>
                                    <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {tableHeaders.year[selectedLang]}
                                    </th>
                                    <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {tableHeaders.excavatedBy[selectedLang]}
                                    </th>
                                    <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {tableHeaders.reference[selectedLang]}
                                    </th>
                                    <th className="py-3 px-4" style={{ borderColor: '#F8D6BF' }}>
                                        {tableHeaders.download[selectedLang]}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {divisionDocs.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} className="py-6 text-gray-500 font-medium">
                                            {selectedLang === 'मराठी' ? "डेटा उपलब्ध नाही" : "No data available"}
                                        </td>
                                    </tr>
                                ) : (
                                    divisionDocs.map((doc, index) => (
                                        <tr key={doc.id} className="hover:bg-[#F6F6EC]">
                                            <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                {selectedLang === 'मराठी' ? convertToMarathiNumber(index + 1) : `${index + 1}`}.
                                            </td>
                                            <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                {doc.place[selectedLang]}
                                            </td>
                                            <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                {doc.year[selectedLang]}
                                            </td>
                                            <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                {doc.excavatedBy[selectedLang]}
                                            </td>
                                            <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                {doc.reference[selectedLang]}
                                            </td>
                                            <td className="py-3 px-4 border-t-2" style={{ borderColor: '#F8D6BF' }}>
                                                <div className="flex justify-center items-center h-full">
                                                    {doc.download ? (
                                                        <a
                                                            href={doc.download}
                                                            download
                                                            title="Download PDF"
                                                            className="text-red-600 hover:text-red-800"
                                                        >
                                                            <FaFilePdf size={20} />
                                                        </a>
                                                    ) : (
                                                        <span>-</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RatnagiriPage;
